import React, { useState, useContext, useMemo, useEffect } from "react";
import Flex from '@react-css/flex';
import Modal from 'react-modal';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledModalCicloAdd } from "../../styled-components/StyledModalCicloAdd.style";
import Swal from "sweetalert2";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { DynamicInput } from "../DynamicInput";
import api from '../../services/api';
import { DynamicInputPME } from "../DynamicInputPME";

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

const MemorizedDynamicInput = React.memo(DynamicInputPME);

export const ModalPerfilPme = ({ isOpen, onAfterOpen, onRequestClose, onUpdatePerfis, selectedPerfil }) => {
    const [nomePerfil, setNomePerfil] = useState("");

    const getPerfil = async(id) => {
        const response = await api.get(`PmePerfil/${id}`, config);
        setNomePerfil(response.data.data.nome);
    };

    useEffect(() => {
        const asyncFn = async () => {
            if (selectedPerfil) {                
               await getPerfil(selectedPerfil);
            }
        }
        asyncFn();

    }, [selectedPerfil]);    

    const registrationFailure = (text = "Ops, ocorreu um erro ao realizar o cadastro. Tente novamente em instantes.") => {
        Swal.fire({
            title: "Atenção",
            text: text,
            icon: "error",
            confirmButtonText: "OK",
        });
    };

    const savePerfil = async () => {
        const payload = {
            id: selectedPerfil || 0, // Se houver ID, atualizar; caso contrário, criar
            nome: nomePerfil,
            status: true,
        };
    
        try {
            const url = selectedPerfil ? 'PmePerfil/atualizar' : 'PmePerfil/salvar';
            const response = await api.put(url, payload);

            Swal.fire({
                title: "Sucesso",
                text: "Perfil salvo com sucesso!",
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
            });

            const novoPerfil = response.data?.data;

            if (typeof onUpdatePerfis === "function") {
                onUpdatePerfis((prevPerfis) => {
                    if (!Array.isArray(prevPerfis)) {
                        // Garante que prevPerfis seja uma lista
                        console.error("onUpdatePerfis recebeu um valor inválido, inicializando como lista vazia.");
                        prevPerfis = [];
                    }
    
                    if (selectedPerfil) {
                        // Atualiza o perfil existente
                        return prevPerfis.map((perfil) =>
                            perfil.id === novoPerfil?.id ? novoPerfil : perfil
                        );
                    } else {
                        // Adiciona um novo perfil
                        return [...prevPerfis, novoPerfil];
                    }
                });
            }

            onRequestClose();

        } catch (error) {
            console.error("Erro ao salvar/atualizar perfil:", error.response?.data || error.message);
        }
    };

    const style = {
        content: {
            top: '45%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: "0px",
            minWidth: '50%',
            overflowY: 'auto',
            minHeight: 'calc(0vh - 250px)',
            maxHeight: 'calc(100vh - 250px)',
        },
        overlay: {
            zIndex: 9999
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onAfterOpen={onAfterOpen}
            onRequestClose={onRequestClose}
            contentLabel="PME - Perfil"
            style={style}
            ariaHideApp={false}
            shouldCloseOnOverlayClick={false}
        >
            <StyledModalCicloAdd>
                <StyledForm>
                    <p className="modal-close" onClick={onRequestClose}>X</p>
                </StyledForm>
                <StyledForm>
                    <div className='row justify-align-content-around mt-3'>
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xxl-12">
                            <MemorizedDynamicInput
                                placeholder=""
                                label="Nome do Perfil*"
                                name={`nomePerfil`}
                                paramMethod={(value) => setNomePerfil(value)}
                                value={nomePerfil}
                            />
                        </div>
                    </div>
                    <div className='d-flex justify-content-center mt-5'>
                        <div className="col-sm-3 col-md-3 col-lg-3">
                            <button type="button" className='default-button-red-small' onClick={() => savePerfil()}>Salvar Perfil</button>
                        </div>
                    </div>
                </StyledForm>
            </StyledModalCicloAdd>
        </Modal>
    );
};